module.exports = __webpack_public_path__ + "static/media/sort-alpha-down.68bfd8c0.svg";